import APIUtils from '@spothero/utils/api';

const ConfigAPI = {
    get() {
        return APIUtils.get('widget-config/');
    }
};

export default ConfigAPI;



// WEBPACK FOOTER //
// ./widget/src/js/api/config.js